/**
 * @generated SignedSource<<f683d3e4a32221284d149f9984374667>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "model"
        }
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "model",
                    "variableName": "model"
                }
            ],
            "concreteType": "UpdateEventPayload",
            "kind": "LinkedField",
            "name": "updateEvent",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "EdgeOfEvent",
                    "kind": "LinkedField",
                    "name": "eventEdge",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Event",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "id",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isCustomSalaryCode",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "EditEventIsCustomSalaryCodeMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "EditEventIsCustomSalaryCodeMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "d2c866594ed0f67be51af7f9216beda4",
            "id": null,
            "metadata": {},
            "name": "EditEventIsCustomSalaryCodeMutation",
            "operationKind": "mutation",
            "text": "mutation EditEventIsCustomSalaryCodeMutation(\n  $model: UpdateEventRequestInput!\n) {\n  updateEvent(model: $model) {\n    eventEdge {\n      node {\n        id\n        isCustomSalaryCode\n      }\n    }\n  }\n}\n"
        }
    };
})();
node.hash = "4380a6c98666296cca53039fa6796822";
export default node;
